import { CrudMode, FormItem, SelectsOptions } from '@ohpen/enso-ui';
import { FieldType } from '@pmp/api';

export const getFormSchema = (selectsOptions: SelectsOptions, mode?: CrudMode | null): FormItem[] => {
  const disabled = mode === CrudMode.VIEW;

  return [
    {
      title: 'pmp.exclusiveProducts.labels.id',
      dataIndex: 'id',
      formItemProps: {
        required: true,
        hidden: mode === CrudMode.CREATE,
      },
      fieldProps: {
        disabled: true,
      },
    },
    {
      title: 'pmp.exclusiveProducts.labels.name',
      dataIndex: 'name',
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled,
      },
    },
    {
      title: 'pmp.exclusiveProducts.labels.description',
      dataIndex: 'description',
      fieldProps: {
        disabled,
      },
    },
    {
      title: 'pmp.exclusiveProducts.labels.startDate',
      dataIndex: 'startDate',
      valueType: 'date',
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled,
      },
    },
    {
      title: 'pmp.exclusiveProducts.labels.endDate',
      dataIndex: 'endDate',
      valueType: 'date',
      fieldProps: {
        disabled,
      },
    },
    {
      title: 'pmp.exclusiveProducts.labels.firms',
      dataIndex: 'lenderFirms',
      valueType: 'select',
      fieldProps: {
        mode: 'multiple',
        options: selectsOptions[FieldType.FIRMS],
        showSearch: true,
        disabled,
      },
    },
  ];
};
